import { useEffect, useState } from 'react';
import { getLanLoc } from './LangFunc';
import { useLocation } from 'react-router-dom';
import { apiMain } from '../../App';
import { PostDataPromise } from './SendingData';

export default function SetHeaders () {
    const location = useLocation();
    let {isEn: lan, isSet} = getLanLoc(location.pathname);
    const [baseData, setBaseData] = useState({
        ip: "",
        useragent: "",
        country: "",
        city: "",
    })
    const [stateHistory, setStateHistory] = useState([]);
    const template = {
        url: "/",
        vi_code: "",
        time: "/",
        Vi_Code: "",
    }
    
    
    useEffect(() => {
        if(lan){
            document.documentElement.style.setProperty('--font', 'var(--font-en)');
        } else {
            document.documentElement.style.setProperty('--font', 'var(--font-fa)');
        }
        if(isSet){
            if(lan){
                localStorage.setItem("luxtrip-lang", "en")
            } else {
                localStorage.setItem("luxtrip-lang", "fa")
            }
        }
        if(location.pathname.search("/admin/") !== -1){
            document.documentElement.style.setProperty('--font', 'var(--font-fa)');
        }
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
        return () => {
        }
      }, [location.pathname]);
    return "";
}

export const setMetaTags = (title, description, noindex = "", canonical = "") => {
    document.title = title;
    
    let meta = document.querySelector('meta[name=description]');
    if(meta){
        meta.remove();
    }
    let metaR = document.querySelector('meta[name=robots]');
    if(metaR){
        metaR.remove();
    }
    let link = document.querySelector('link[rel=canonical]');
    if(link){
        link.remove();
    }

    let desc = document.createElement("meta");
    desc.name = 'description';
    desc.content = description;
    document.getElementsByTagName('head')[0].appendChild(desc);

    if(noindex.length > 0){
        let robots = document.createElement("meta");
        robots.name = 'robots';
        robots.content = "noindex,nofollow";
        document.getElementsByTagName('head')[0].appendChild(robots);
    }
    if(canonical.length > 0){
        let cano = document.createElement("link");
        cano.rel = 'canonical';
        cano.href = canonical;
        document.getElementsByTagName('head')[0].appendChild(cano);
    }
}

let viewData = {
    baseData: {
        ip: "",
        country: "",
        city: "",
        useragent: "",
        timezone: ""
    },
    stateHistory: [],
};
export const makeViewEvent = async (vi_code, vi_req) => {
    let newurl = window.location.pathname
    let newBaseData = viewData.baseData;
    if(viewData.baseData.ip === ""){
        let loc = await fetch('http://ip-api.com/json');
        let data = JSON.parse(await loc.text());
        newBaseData = {
            ip: data.query,
            country: data.country,
            city: data.city,
            timezone: data.timezone,
            useragent: window.navigator.userAgent,
        }
        viewData.baseData = newBaseData
    }

    // validate history;
    let nowTime = Date.now()
    let findUrl = viewData.stateHistory.findIndex((v) => {
        if(v.time < nowTime - (60*60*1000)){
            return false
        }
        if(v.url === newurl){
            return true;
        }
    });
    if(findUrl === -1){
        // save history data for validation;
        viewData.stateHistory.push({
            url: newurl,
            time: nowTime,
            Vi_Code: "",
        })
        ///api/v1/campaign/viewevent/insert
        let formdata = new FormData();
        let userdata = (localStorage.getItem("luxtrip-user")) ? JSON.parse(localStorage.getItem("luxtrip-user")): {};
        if(userdata.U_CODE){
            formdata.append("U_CODE", userdata.U_CODE);
        }

        formdata.append("Views_Ev_IP", newBaseData.ip);
        formdata.append("Views_Ev_Agent", newBaseData.useragent);
        formdata.append("Views_Ev_Country", newBaseData.country);
        formdata.append("Views_Ev_Zone", newBaseData.timezone);
        formdata.append("Vi_Code", vi_code);
        if(vi_req === undefined){
            formdata.append("Vi_Required", "");
        } else {
            formdata.append("Vi_Required", vi_req);
        }
        formdata.append("Views_Ev_Type", 0);

        let response = await PostDataPromise(apiMain + "/api/v1/campaign/viewevent/insert", formdata);
    }
}